<div class="container-box">
  <app-table-header
    tableTitle="Tipo servizi assicurativi"
    (btnUpdateClick)="loadInsuranceServiceTypes()"
  >
    <app-button-new-insurance-service-type action-button></app-button-new-insurance-service-type>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="insuranceServiceTypesTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
